import {
  getSSMClient,
  newParameterStoreService,
  newParameterValueService,
  newSSMParameterRepository,
} from '@nucleus/lib-parameter-store';
import { NameGeneratorFactory } from './stage';

const Repository = newSSMParameterRepository(getSSMClient());

const ElasticSearchParameterStoreService = newParameterStoreService(Repository, {
  nameGenerator: NameGeneratorFactory('ElasticSearch'),
});

/**
 * SSM Parameter /${STAGE}/ElasticSearch/endpoint
 */
export const ElasticSearchEndpoint = newParameterValueService(ElasticSearchParameterStoreService, 'endpoint');

/**
 * SSM Parameter /${STAGE}/ElasticSearch/apiKey
 */
export const ElasticSearchApiKey = newParameterValueService(ElasticSearchParameterStoreService, 'apiKey');
